import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    View,
    Text,
    TextInput,
    TouchableHighlight,
    Platform,
    KeyboardAvoidingView,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from "expo-secure-store";
import {
    loginUser,
    createApiAuthToken,
    verifyUserIsLoggedIn
} from "../reducers/cbcAuthorizationSlice";
import styled from 'styled-components/native';
import {
    WorkoutContainerHeaderTwo,
    WorkoutContainerHeaderThree,
    WorkoutContainerText,
    WorkoutTextHeader,
    WorkoutTextSubHeader,
    WorkoutCommonButton,
    WorkoutButtonTwo
} from "../styles/common-styles";

import { clearState} from "../reducers/cbcAuthorizationSlice";

import ForgotPassword from "./ForgotPassword";
import { LinearGradient } from 'expo-linear-gradient';
import {PivotLogging} from "../reducers/cbcLoggingSlice";
import {checkReminderMessages} from "../reducers/cbcReminderMessagesSlice";

import checkReminderMessagesFunction from "../hooks/checkReminderMessages";
import useLocalNotification from "../hooks/localNotificationHandler";
import useLocalNotificationJSONManager from "../hooks/useLocalNotificationJSONManager";
import {fetchAllCurrentActivities} from "../reducers/cbcActivitiesSlice";
function Login(props) {
    const dispatch = useDispatch();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loginView, setLoginView] = useState('login');
    const [headerMessage, setHeaderMessage] = useState('Welcome to CerebroCore');
    const {
        scheduleNotification,
        scheduleRecurringNotification,
        getAllScheduledNotifications,
        cancelNotification
    } = useLocalNotification();
    const {
        notificationGroups,
        createNotificationGroup,
        updateNotificationGroup,
        deleteNotificationGroup,
        loadNotificationGroups,
        saveNotificationGroups,
        createNotificationGroupFromDetails
    } = useLocalNotificationJSONManager();

    const {
        userId,
        wpAuthorizationToken,
        authLoading,
        authResultMessage,
        apiAuthToken,
    } = useSelector((state) => state.cbcAuthorization);

    const { results_msg } = useSelector((state) => state.accountActions);

    // useEffect(() => {
    //     dispatch(clearState());
    // },[])

    useEffect(() => {
        dispatch(PivotLogging({moduleName: 'Login' , consoleLog: 'Login Screen'}));
        async function useSavedCredentials() {
            const savedUsername = await SecureStore.getItemAsync('username');
            dispatch(PivotLogging({moduleName: 'Login' , consoleLog: `Username ${savedUsername}`}));
            const savedPassword = await SecureStore.getItemAsync('password');
            dispatch(PivotLogging({moduleName: 'Login' , consoleLog: `Password ${savedPassword}`}));
            if (savedUsername !== undefined) {
                setUsername(savedUsername);
                setPassword(savedPassword);
            }
        }
        dispatch(PivotLogging({moduleName: 'Login' , consoleLog: `Platform ${Platform.OS}`}));
        if (Platform.OS !== 'web') {
            useSavedCredentials();
        }
    }, []);

    useEffect(() => {
        async function processLogin() {
            dispatch(PivotLogging({moduleName: 'Login' , consoleLog: `Authorization Token ${wpAuthorizationToken}`}));
            if (wpAuthorizationToken.length > 0) {
                await AsyncStorage.setItem('userId', userId.toString());
                await SecureStore.setItemAsync('authToken', wpAuthorizationToken);
                console.log('processLogin' , userId , wpAuthorizationToken);
                dispatch(
                    createApiAuthToken({
                        userId: userId,
                        jwtAuthToken: wpAuthorizationToken,
                    })
                );
            }
        }
        processLogin();
    }, [wpAuthorizationToken]);

    useEffect(() => {
        console.log('apiAuthToken' , apiAuthToken);
        async function processNewApiToken() {
            dispatch(PivotLogging({moduleName: 'Login' , consoleLog: `Api Token: ${apiAuthToken}`}));
            if (apiAuthToken.length > 0 && userId > 0) {
                console.log('navigating to dashboard');
                console.log(
                    userId,
                    wpAuthorizationToken,
                    authLoading,
                    authResultMessage,
                    apiAuthToken)
                await SecureStore.setItemAsync('apiAuthToken', apiAuthToken);
                dispatch(checkReminderMessages(userId)).then((e) => {
                    console.log('checkReminderMessages load screen' , e);
                    checkReminderMessagesFunction(
                        scheduleNotification,
                        scheduleRecurringNotification,
                        cancelNotification,
                        notificationGroups,
                        {
                            createNotificationGroup,
                            updateNotificationGroup,
                            deleteNotificationGroup,
                            loadNotificationGroups,
                            saveNotificationGroups,
                            createNotificationGroupFromDetails
                        }
                    );
                });
                // navigate to the workout dashboard
                //alert(`${authLoading} ${authResultMessage}`);
                dispatch(PivotLogging({moduleName: 'Login' , consoleLog: 'Go to dashboard'}));
                dispatch(fetchAllCurrentActivities({}))
                props.navigation.navigate('tabnavigator');
            }
        }
        processNewApiToken();
    }, [apiAuthToken]);

    function sanitizeString(str) {
        let sanitized = str.replace(/<[^>]*>/g, '');
        sanitized = sanitized.replace(/http[s]?:\/\/[^ ,\)\(\n]*/g, '');
        sanitized = sanitized.replace(/Error:/g, '');
        sanitized = sanitized.replace(/Lost your password\?/g, '');

        dispatch(PivotLogging({moduleName: 'Login' , consoleLog: sanitized}));

        const conditions = {
            'The password you entered for the username': {
                headerText: "Oops, something's not right",
                bodyText:
                    "The username or password you entered isn't correct. Please try again or reset your password.",
            },
            'The password you entered for the email': {
                headerText: "Oops, something's not right",
                bodyText:
                    "The email or password you entered isn't correct. Please try again or reset your password.",
            },
            'If you are unsure of your username': {
                headerText: "Oops, something's not right",
                bodyText:
                    "The username or password you entered isn't correct. Please try again or reset your password.",
            },
            'field is empty': {
                headerText: "Oops, something's not right",
                bodyText:
                    "The username or password you entered isn't correct. Please try again or reset your password.",
            },
            Logging: {
                headerText: 'Logging you in',
                bodyText: 'Hang tight',
            },
        };

        let headerText = 'Start Training';
        let bodyText = 'Sign in to get started';

        Object.keys(conditions).forEach((condition) => {
            if (sanitized.includes(condition)) {
                headerText = conditions[condition].headerText;
                bodyText = conditions[condition].bodyText;
            }
        });

        return (
            <View style={{ marginTop: 10, marginBottom: 10, width: 300 }}>
                <WorkoutTextHeader
                    style={{ color: 'white', textAlign: 'center', marginBottom: 5 }}
                >
                    {headerText}
                </WorkoutTextHeader>
                <WorkoutContainerText style={{ color: 'white', textAlign: 'center' }}>
                    {bodyText}
                </WorkoutContainerText>
            </View>
        );
    }

    useEffect(() => {
        console.log('results_msg' , results_msg)
        try {
            if (results_msg.includes('Successfully sent password reset email.')) {
                setHeaderMessage('Successfully sent password reset email.');
            }
        } catch (e){
            console.log(e);
        }
    }, [results_msg]);

    useEffect(() => {
        console.log(authResultMessage);
        setHeaderMessage(authResultMessage);
    }, [authResultMessage]);

    const onForgotPasswordClick = () => {
        setLoginView('forgotpassword');
    };

    const returnToLogin = () => {
        setLoginView('login');
    };

    return (
        <LoginContainer
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
            style={{
                width: '100%',
                height: '100%',
                flex: 1,
            }}
        >
            <LinearGradient
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                }}
                colors={['rgb(65, 103, 176) ', 'rgb(192, 77, 151)']}
            />

            <LoginImg
                source={{
                    uri: 'https://cerebrocoreusa.com/wp-content/uploads/2022/04/CerebroCore_Primarylogos_BrainOp_White_640.png',
                }}
                resizeMode='contain'
            />

            {loginView == 'login' && (
                <>
                    {sanitizeString(headerMessage)}
                    {/* <WorkoutContainerHeaderTwo>Username</WorkoutContainerHeaderTwo> */}
                    <LoginInput
                        autoCorrect={false}
                        autoCapitalize='none'
                        onChangeText={(text) => setUsername(text)}
                        value={username}
                        placeholder='Email'
                    />
                    {/* <WorkoutContainerHeaderTwo style={{marginTop: 30}}>Password</WorkoutContainerHeaderTwo> */}
                    <LoginInput
                        autoCorrect={false}
                        autoCapitalize='none'
                        onChangeText={(text) => setPassword(text)}
                        value={password}
                        secureTextEntry={true}
                        placeholder='Password'
                    />

                    {authLoading !== 'pending' && (
                        <WorkoutCommonButton
                            style={{ marginTop: 20 }}
                            onPress={() => {
                                //console.log('username' , username);
                                //console.log('password' , password);
                                dispatch(loginUser({ username: username, password: password }))
                            }}
                        >
                            <WorkoutContainerText
                                style={{ color: 'white', fontWeight: '500' }}
                            >
                                LOGIN
                            </WorkoutContainerText>
                        </WorkoutCommonButton>
                    )}
                    <TouchableHighlight
                        style={{ marginTop: 15 }}
                        onPress={() => onForgotPasswordClick()}
                    >
                        <WorkoutContainerText
                            style={{
                                color: 'white',
                                textDecorationLine: 'underline',
                                fontSize: 15,
                            }}
                        >
                            Forgot Password
                        </WorkoutContainerText>
                    </TouchableHighlight>
                </>
            )}

            {loginView == 'forgotpassword' && (
                <>
                    <ForgotPassword
                        callbackFunction={returnToLogin}
                        route={props.route}
                        navigation={props.route.navigation}
                        invokedFromSettings={0}
                    />
                </>
            )}
        </LoginContainer>
    );
}

const LoginContainer = styled.KeyboardAvoidingView`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginInput = styled.TextInput`
  border: 0.5px solid lightgray;
  background: #fff;
  border-radius: 5px;
  width: 275px;
  height: 40px;
  margin-top: 10px;
  padding: 10px;
  font-size: 18px;
`;

const LoginText = styled.Text`
  margin-top: 15px;
  font-size: 24px;
`;

const LoginImg = styled.Image`
  width: 100%;
  height: 125px;
  margin-bottom: 25px;
  padding-right: 25px;
  padding-left: 25px;
`;

export default Login;
